import { useState, useEffect } from "react";
import { Lightbulb } from "lucide-react";
const TIPS = [
  "Progress over perfection: Small steps forward are still victories.",
  "Your feelings are valid. It's okay to not feel okay sometimes.",
  "Taking breaks is not laziness - it's self-care.",
  "Asking for help is a sign of strength, not weakness.",
  "Focus on what you can control, let go of what you cannot.",
  "Consistency beats intensity. Show up for yourself.",
  "Celebrate small wins - they matter.",
  "Your mental health is as important as your physical health.",
  "Be kind to yourself like you would to a good friend.",
  "You deserve rest without guilt.",
];
function getTip() { const now = new Date(); const start = new Date(now.getFullYear(), 0, 0); const day = Math.floor((now - start) / 86400000); return TIPS[day % TIPS.length]; }

export default function MentalHealthTip() {
  const [tip, setTip] = useState("");
  useEffect(() => { setTip(getTip()); }, []);
  return (
    <div className="bg-gradient-to-r from-primary/10 to-secondary/10 border border-primary/20 rounded-xl p-4 flex items-start gap-3 animate-fade-in" data-testid="mental-health-tip">
      <Lightbulb className="w-5 h-5 text-primary shrink-0 mt-0.5" />
      <div><p className="text-xs uppercase font-semibold text-muted-foreground tracking-widest mb-1">Mental Health Tip of the Day</p><p className="text-sm font-medium text-foreground leading-relaxed">{tip}</p></div>
    </div>
  );
}
